import { Component, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { I18nService } from "@bitwarden/common/abstractions/i18n.service";
import { ActionButton } from "@bitwarden/web-vault/app/components/buttons/gloss-button/actionButton";
import { ClassificationAddEditComponent } from "@bitwarden/web-vault/app/gloss/manage/manage-classifications/classification-add-edit/classification-add-edit.component";
import { manageButtonProperties } from "@bitwarden/web-vault/app/gloss/manage/manage.components";
import { ConfirmationDialogService } from "@bitwarden/web-vault/app/services/confirmation/confirmation.service";
import { TablesFactory } from "@bitwarden/web-vault/app/components/tables/tables.factory";
import { TablesType } from "@bitwarden/web-vault/app/models/enum/tables.enum";
import { DialogWrapperComponent } from "@bitwarden/web-vault/app/components/wrappers/dialog-wrapper/dialog-wrapper.component";
import { NotificationEnum } from "@bitwarden/web-vault/app/models/enum/notification.enum";
import { ClassificationTable } from "@bitwarden/web-vault/app/components/tables/classification-tables/classification.table";
import { DeviceDetectorService } from "ngx-device-detector";
import { mobileSlideInConfig } from "@bitwarden/web-vault/app/components/dialog/mobile-slide-in-dialog";

@Component({
  selector: "app-manage-classifications",
  templateUrl: "./manage-classifications.component.html",
})
export class ManageClassificationsComponent {
  loading = false;
  table: ClassificationTable = new TablesFactory().get(TablesType.Classifications, this);
  private notifyService: ConfirmationDialogService = inject(ConfirmationDialogService);
  private i18nService = inject(I18nService);
  protected deviceDetectorService = inject(DeviceDetectorService);

  constructor(public dialog: MatDialog) {}

  addClassificationButton = new ActionButton({
    ...manageButtonProperties,
    text: this.i18nService.t("createNew"),
    onClick: this.addClassification.bind(this),
  });

  searchText = "";

  async addClassification() {
    this.dialog.open(DialogWrapperComponent, {
      ...mobileSlideInConfig("no-background-dialog"),
      disableClose: true,
      data: {
        title: "createNewClassification",
        showBackButton: false,
        component: ClassificationAddEditComponent,
        fullyCustomised: true,
        showHeaderCloseButton: true,
        componentInputs: {
          classification: null,
          actionSucceeded: this.actionSucceeded.bind(this),
        },
      },
    });
  }

  cleanSelectedClassification() {
    this.table.selectedClassification.set(null);
  }

  onSearchChange(searchValue: string): void {
    this.table.gridApi.setFilterModel({
      name: {
        type: "contains",
        filter: searchValue,
      },
    });
  }

  actionSucceeded(actionKey: { newClassificationText: string; successfulText: string }) {
    this.notifyService.notify(NotificationEnum.success, "succeeded", actionKey.successfulText);
    const created = this.table.data()?.find((c) => c.name === actionKey.newClassificationText);
    if (created) {
      this.table.onRowClicked(created);
    } else {
      this.cleanSelectedClassification();
    }
  }
}
